import type { StepState } from './state';
import { HOSTED_ONLY_STEPS, type OnboardingStep, STEP_ORDER } from './step';

/** The previous step in the flow, skipping the Hosted-only steps on the embedded path. */
export const getPreviousStep = (
  current: OnboardingStep,
  state?: StepState,
): OnboardingStep | null => {
  let idx = STEP_ORDER.indexOf(current);
  if (idx <= 0) {
    return null;
  }
  let prev: OnboardingStep = STEP_ORDER[idx - 1];
  while (state?.recommendedVariant === 'embedded' && HOSTED_ONLY_STEPS.has(prev)) {
    idx--;
    /* v8 ignore next 3 -- defensive: the hosted-only steps never sit at the start of STEP_ORDER, so this guard can't trip with the current order */
    if (idx <= 0) {
      return null;
    }
    prev = STEP_ORDER[idx - 1];
  }
  return prev;
};
